import { BoxProps, Center, Spinner, SpinnerProps } from '@chakra-ui/react';
import React from 'react';

type DefaultSpinnerProps = BoxProps & { spinnerProps?: SpinnerProps };

export const DefaultSpinner: React.FC<DefaultSpinnerProps> = ({
  h = '100vh',
  spinnerProps = { size: 'xl' },
  ...props
}) => {
  return (
    <Center h={h} {...props}>
      <Spinner {...spinnerProps} />
    </Center>
  );
};
